import React from 'react';

import {
  tableRowHeightInRem,
  iconButtonOffset,
  iconButtonMidpointX,
  iconButtonIconRightX,
  iconButtonMidpointY,
  iconButtonIconTopY,
  iconButtonIconBottomY,
  svgWidthInRem,
  treeLineStyle,
  showTop,
  showRight,
  showBottom,
} from './tree_line';

/**
 * Creates a tree line along with an expand button.
 */
export default class TreeLineButton extends React.Component {
  render() {
    const { level, mode, expand, expandButton } = this.props;

    return (
      <div
        className="ui-util-mv-i-s"
        style={{
          left: level > 1 ? iconButtonOffset + 2 * level + `rem` : iconButtonOffset + 2 * (level + 1) + `rem`,
          top: `-1rem`,
          height: `0rem`,
          position: 'relative',
        }}
      >
        <svg
          style={{
            position: 'absolute',
            top: expand !== 'top' ? `0.5rem` : `-1.7rem`,
            left: `1rem`,
            right: 0,
            bottom: 0,
            width: `${svgWidthInRem}rem`,
            height: `${tableRowHeightInRem}rem`,
          }}
          viewBox={`0 0 ${svgWidthInRem} ${tableRowHeightInRem}`}
        >
          {showTop(mode) && (
            <line
              x1={`${iconButtonMidpointX}`}
              y1="0"
              x2={`${iconButtonMidpointX}`}
              y2={`${iconButtonIconTopY}`}
              style={treeLineStyle}
            />
          )}
          {showBottom(mode) && (
            <line
              x1={`${iconButtonMidpointX}`}
              y1={`${tableRowHeightInRem}`}
              x2={`${iconButtonMidpointX}`}
              y2={`${iconButtonIconBottomY}`}
              style={treeLineStyle}
            />
          )}
          {showRight(mode) && (
            <line
              x1={`${iconButtonIconRightX}`}
              y1={`${iconButtonMidpointY}`}
              x2={`${svgWidthInRem}`}
              y2={`${iconButtonMidpointY}`}
              style={treeLineStyle}
            />
          )}
        </svg>
        <span style={{ marginLeft: `1rem` }} />
        {expandButton}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/reports/components/tree_line_button.js